export default __webpack_public_path__ + "static/media/office-circ.65a9af27.svg";